const resetPassword = {
  resetPasswordTitle: 'Setzen Sie Ihr Passwort zurück',
  resetNotSuccess: 'or contact michael@moovex.com,Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder kontaktieren Sie michael@moovex.com, or contact michael@moovex.com',
  resetPasswordBtn: 'Weitermachen',
  resetPasswordHint: 'Bitte geben Sie ein neues Passwort ein.',
  resetSuccessful: 'Sie haben Ihr Passwort erfolgreich geändert.',
  backToLogIn: 'Bitte kehren Sie zur Anmeldung zurück und melden Sie sich erneut an',
  newPassword: 'Neues Passwort',
  reEnterPassword: 'Bestätigen Sie Ihr Passwort',
};

export default resetPassword;
